<template>
  <footer>
    <b-container>
      <h1 v-t="'reserveNow'"></h1>
      <b-row align-h="center" class="mt-4">
        <b-col lg="2" md="12" class="mb-4"> <b-button variant="primary" href="tel:210312807">210 312 807</b-button> </b-col>
        <b-col lg="2" md="12" class="mb-4"> <b-button variant="primary" href="tel:919878409">919 878 409</b-button> </b-col>
        <b-col lg="2" md="12" class="mb-4"> <b-button variant="primary" class="is--email" href="mailto:info@lismarketing.pt">info@lismarketing.pt</b-button> </b-col>
      </b-row>
      <hr>

      <b-row class="links">
          <b-col md=6 class="mb-3">
            {{ $t('copyright') }}
          </b-col>
          <b-col class="links__right mb-3" md=6><a href="https://www.visitlisboa.com/pt-pt"><b v-t="'returnSite'"></b></a></b-col>
          <b-col class="links__socials">
            <span v-t="'followUs'"></span>
            <a href="https://www.pinterest.pt/visitlisboa/"><i class="icon-pinterest"></i></a>
            <a href="https://www.youtube.com/user/VisitLisboa"><i class="icon-youtube"></i></a>
            <a href="https://twitter.com/TurismodeLisboa"><i class="icon-twitter"></i></a>
            <a href="https://www.facebook.com/visitlisboa"><i class="icon-facebook"></i></a>
            <a href="https://www.instagram.com/visit_lisboa/"><i class="icon-instagram"></i></a>
          </b-col>
      </b-row>

      <b-row class="mt-5 text-left">
        <b-col md=6 class="mb-3 links__logos" >
          <a href="https://www.visitlisboa.com/pt-pt" target="_blank"><img src="@/assets/images/logo.png" /></a>
          <a href="http://www.ertlisboa.pt/" target="_blank" rel="noopener" class="ml-4"><img src="@/assets/images/ert-alto.jpg" /></a>
        </b-col>
      </b-row>
    </b-container>
    <cookie-law theme="custom" class="justify-content-center" v-on:accept="enableAnalytics()">
      <div class="d-flex align-items-center justify-content-between" slot-scope="props">
        <div class="Cookie__content">
          <div>Este site usa cookies para recolher indicadores de acesso ao website.</div>
        </div>
        <div class="Cookie__buttons">
          <button class="Cookie__button" @click="props.accept"><span>Aceitar</span></button>
        </div>
      </div>
    </cookie-law>
  </footer>
</template>

<script>
  import CookieLaw from 'vue-cookie-law'
  import { bootstrap } from 'vue-gtag'
  
  export default {
    components: { CookieLaw },
    methods: {
      enableAnalytics() {
        if (navigator.doNotTrack !== '1') bootstrap()
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/assets/variables';


footer {
  background: $color-black;
  color: $color-white;

  .container {
    padding: 50px 0;

    > hr {
      background: $darkened-primary-color;
    }

    a {
      color: $color-white;
      white-space: nowrap;
    }
  }

  .btn {
    &:before {
      content: url("../assets/images/icons/phone.svg");
      background: white;
      height: 1.25rem;
      width: 1.25rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      margin-right: 0.625rem;

      padding-bottom: 1px;
      padding-left: 1px;
    }

    &.is--email {
      &::before {
        content: url("../assets/images/icons/envelope.svg");
      }
    }
  }

  .row {
    margin: 0;
  }

  .links {

    text-align: center;

    @media (min-width: $breakpoint-large) {
      text-align: left;
    }

    &__socials {
      > * {
        margin-right: 10px;
      }

      a {
        font-size: 1.125rem;

        &:hover {
          color: $primary-color;
          text-decoration: none;
        }
      }
    }

    &__right {
      @media (min-width: $breakpoint-large) {
        text-align: right;
      }
    }

    &__logos {
      img {
        height: 7.5rem;
      }
      
    }

  } 
}
</style>